// Define interfaces for the data structure
interface User {
	id: string
	firstName: string
	lastName: string
	email: string
	phone: string
	address: string
	address2: string
	city: string
	state: string
	zip: string
	country: string
	image: string
	addressConfirmed: boolean
}

interface UserState {
	user: User | null
}

// Helper to validate and normalize country/state
// If the country is not a valid ISO2 or ISO3 value, then set the values to blank and force the addressConfirmed state to false
const defaultBadData = { country: "", state: "", addressConfirmed: false }
function getValidCountryAndState(country: string, state: string, addressConfirmed: boolean) {
	const { $countryAndStatesService } = useNuxtApp()
	if (!country) {
		return defaultBadData
	}

	let validCountry = ""
	if (country.length === 3) {
		validCountry = ($countryAndStatesService as any).$getCountryByIsoCode(country)
	} else if (country.length === 2) {
		validCountry = ($countryAndStatesService as any).$convertIso2ToIso3(country)
	}

	if (!validCountry) {
		return defaultBadData
	}

	return { country: country, state: state ?? "", addressConfirmed: addressConfirmed ?? false }
}

function convertJsonToUser(json: any): User {
	let { country, state, addressConfirmed } = getValidCountryAndState(json.country, json.state, json.address_confirmed)

	return {
		id: json.id,
		firstName: json.first_name,
		lastName: json.last_name,
		email: json.email,
		phone: json.phone,
		address: json.address,
		address2: json.address2,
		city: json.city,
		state: state,
		zip: json.zip,
		country: country,
		image: json.image,
		addressConfirmed: addressConfirmed,
	}
}

// Define the Pinia store
export const useUserStore = defineStore("userStore", {
	state: (): UserState => ({
		user: null,
	}),

	getters: {
		getUser: (state: UserState) => state.user,
	},

	actions: {
		storeUserFromJson(user: any) {
			this.user = convertJsonToUser(user)
		},
		clear() {
			this.user = null
		},
	},

	persist: {
		key: "up_userStore", // Make sure this key is unique
		storage: localStorage, // or cookies if you're using cookie storage
	},
})
